<template>
    <v-card width="100%" :height="height" class="myprovet-card mx-auto" v-bind="$attrs">
        <slot name="title" />

        <v-card-text v-if="hasSlot('content')" :class="{ 'myprovet-card-info-content-scroll': contentIsScrollable }" :style="contentStyle">
            <slot name="content" />
        </v-card-text>

        <v-card-text v-if="hasSlot('content-no-margin')" class="px-0" :class="{ 'myprovet-card-info-content-scroll': contentIsScrollable }" :style="contentStyle">
            <slot name="content-no-margin" />
        </v-card-text>

        <v-card-text v-if="hasSlot('sidebar-content-no-margin')" class="px-0 sidebar-content d-flex flex-column" :class="{ 'myprovet-card-info-content-scroll': contentIsScrollable }" :style="contentStyle">
            <slot name="sidebar-content-no-margin" />
        </v-card-text>

        <slot name="image" />
    </v-card>
</template>

<script>
export default {
    name: 'AppCard',

    props: {
        height: { default: '' },
        contentStyle: { default: '' },
        items: { title: '', subtitle: '', icon: '', url: '' },
        contentIsScrollable: { default: false },
    },

    methods: {
        hasSlot(name = 'default') {
            return !!this.$slots[name] || !!this.$scopedSlots[name];
        },
    },
};
</script>
